import { faUser } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Fragment, useState } from "react";
import { Alert, Col, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import $ from "jquery";

const Avatar = (props) => {
    const { t } = useTranslation();
    const { user, avatar, setAvatar, formChanged, setFormChanged } = props;
    const [invalidFile, setInvalidFile] = useState(null);

    const uploadNewFile = (event) => {
        const newFile = event.target.files[0];

        if (newFile) {
            /* 16777216 - 16 MB, 2097152 - 2MB, 204800 - 200 KB */
            if (newFile.type !== "image/png" && newFile.type !== "image/jpeg") setInvalidFile("invalidFileFormat");
            else if (newFile.size > 2048000) setInvalidFile("tooBigFile");
            else {
                setInvalidFile(false);
                var reader = new FileReader();
                reader.onload = function (e) {
                    $(`#avatar`).attr("src", e.target.result);
                    $(`#avatar`).attr("alt", "newAvatar");
                };
                reader.readAsDataURL(newFile);
                setAvatar(newFile);
                setFormChanged(true);
            }
        }
    };

    return (
        <Fragment>
            <Col xs={4} className="text-center mb-3">
                <div className="avatar mx-auto d-inline-block">
                    {user.avatar_name ? (
                        //${process.env.REACT_APP_API_URL}/uploads/usersAvatars
                        <Image src={`${process.env.REACT_APP_API_URL}/uploads/usersAvatars/${user.avatar_name}`} alt={`${user.name} ${user.surname} avatar`} id="avatar" />
                    ) : !avatar || avatar === "noFile" ? (
                        <FontAwesomeIcon icon={faUser} />
                    ) : formChanged ? (
                        <Image src={`${process.env.REACT_APP_API_URL}/uploads/usersAvatars/${user.avatar_name}`} alt={`${user.name} ${user.surname} avatar`} id="avatar" />
                    ) : (
                        <img src={`data:${avatar.type};base64,${avatar.data}`} alt={avatar.name} id="avatar" />
                    )}
                </div>
            </Col>
            <Col xs={8} className="">
                <p className="mb-1 mb-lg-3">{t("users.profilePicture")}</p>
                <p className="mb-1 mb-lg-3 text-small">{t("users.maxFile")}</p>
                <div className="input-group mb-3">
                    <div className="choose-file">
                        <input
                            type="file"
                            className="choose-file-input btn-outline-secondary"
                            id="chooseFile"
                            name="avatar_file"
                            onChange={(e) => uploadNewFile(e)}
                            accept="image/x-png,image/jpeg"
                        />
                        <label className="choose-file-label btn btn-outline-secondary" htmlFor="chooseFile" aria-describedby="chooseFileAddon">
                            {t("users.chooseNewAvatar")}
                        </label>
                    </div>
                </div>
            </Col>
            {invalidFile && (
                <Col xs={12} className="text-center">
                    <Alert variant="danger" className="alert-small">
                        {t(`error.${invalidFile}`)}
                    </Alert>
                </Col>
            )}
        </Fragment>
    );
};

export default Avatar;
